import { render, staticRenderFns } from "./mahjong-calculator.vue?vue&type=template&id=1eb619a8&scoped=true"
import script from "./mahjong-calculator.vue?vue&type=script&lang=js"
export * from "./mahjong-calculator.vue?vue&type=script&lang=js"
import style0 from "../mahjong-tiles.less?vue&type=style&index=0&lang=less"
import style1 from "./mahjong-calculator.vue?vue&type=style&index=1&id=1eb619a8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb619a8",
  null
  
)

export default component.exports